import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HomeService {
  private sideMenuSubject = new Subject<boolean>();

  setSideMenuStatus(bool: boolean) {
    this.sideMenuSubject.next(bool);
  }

  getSideMenu(): Observable<boolean> {
    return this.sideMenuSubject.asObservable();
  }
}
